import { lazyPreload } from 'helpers/lazyPreload'

export { LandingWellness } from './LandingWellness'

export const AppWellness = lazyPreload(() =>
  import('./AppWellness').then((m) => ({ default: m.AppWellness })),
)

export const DownloadWellness = lazyPreload(() =>
  import('./DownloadWellness').then((m) => ({ default: m.DownloadWellness })),
)
export { AlternativeAyahLoader } from './Intro/IntroLoader/AlternativeAyahLoader'
export { KnowledgeQuizIntro } from './Intro/IntroLoader/KnowledgeQuizIntro'

export const Advantages = lazyPreload(() =>
  import('./Advantages').then((m) => ({ default: m.Advantages })),
)

export const AlmostThere = lazyPreload(() =>
  import('./AlmostThere').then((m) => ({ default: m.AlmostThere })),
)

export const AlmostThereV2 = lazyPreload(() =>
  import('./AlmostThere').then((m) => ({ default: m.AlmostThereV2 })),
)

export const AlmostThereV4 = lazyPreload(() =>
  import('./AlmostThere').then((m) => ({ default: m.AlmostThereV4 })),
)

export const AnimatedStepFactory = lazyPreload(() =>
  import('./AnimatedStep').then((m) => ({ default: m.AnimatedStepFactory })),
)

export const AttachmentSummaryV3 = lazyPreload(() =>
  import('./DependenceSummary').then((m) => ({
    default: m.AttachmentSummaryV3,
  })),
)

export const BreakAyahV1 = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.BreakAyahV1 })),
)

export const BreakAyahV2 = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.BreakAyahV2 })),
)

export const BreakAyahV3 = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.BreakAyahV3 })),
)

export const QuoteBreak = lazyPreload(() =>
  import('./QuoteBreak').then((m) => ({ default: m.QuoteBreak })),
)

export const BreakNotPerfect = lazyPreload(() =>
  import('./BreakNotPerfect').then((m) => ({ default: m.BreakNotPerfect })),
)

export const BreakHalfway = lazyPreload(() =>
  import('./BreakHalfway').then((m) => ({ default: m.BreakHalfway })),
)

export const BreakQuizStart = lazyPreload(() =>
  import('./BreakQuizStart').then((m) => ({ default: m.BreakQuizStart })),
)

export const BreakEveryHeart = lazyPreload(() =>
  import('./BreakEveryHeart').then((m) => ({ default: m.BreakEveryHeart })),
)

export const BreakDidGreat = lazyPreload(() =>
  import('./BreakDidGreat').then((m) => ({ default: m.BreakDidGreat })),
)

export const BreakDoorOpens = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.BreakDoorOpens })),
)

export const BreakBuildingProfile = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({
    default: m.BreakBuildingProfile,
  })),
)

export const BreakGatheredProfile = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({
    default: m.BreakGatheredProfile,
  })),
)

export const BreakShortSessions = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({
    default: m.BreakShortSessions,
  })),
)

export const BreakRightPlace = lazyPreload(() =>
  import('./BreakRightPlace').then((m) => ({ default: m.BreakRightPlace })),
)

export const BreakRightPlaceV2 = lazyPreload(() =>
  import('./BreakRightPlace').then((m) => ({ default: m.BreakRightPlaceV2 })),
)

export const BuddhistArchetype = lazyPreload(() =>
  import('./BreakScreenKarma').then((m) => ({ default: m.BuddhistArchetype })),
)

export const CommitmentPromise = lazyPreload(() =>
  import('./CommitmentPromise').then((m) => ({ default: m.CommitmentPromise })),
)

export const CreatePlan = lazyPreload(() =>
  import('./CreatePlan').then((m) => ({ default: m.CreatePlan })),
)

export const DangerousSymptoms = lazyPreload(() =>
  import('./DangerousSymptoms').then((m) => ({ default: m.DangerousSymptoms })),
)

export const DependenceSummary = lazyPreload(() =>
  import('./DependenceSummary').then((m) => ({ default: m.DependenceSummary })),
)

export const DependenceSummaryV2 = lazyPreload(() =>
  import('./DependenceSummary').then((m) => ({
    default: m.DependenceSummaryV2,
  })),
)

export const DidYouKnowLoader = lazyPreload(() =>
  import('./Intro').then((m) => ({ default: m.DidYouKnowLoader })),
)

export const EmotionalBlockage = lazyPreload(() =>
  import('./BreakScreenKarma').then((m) => ({ default: m.EmotionalBlockage })),
)

export const EnergyField = lazyPreload(() =>
  import('./BreakScreenKarma').then((m) => ({ default: m.EnergyField })),
)

export const FamiliesLearning = lazyPreload(() =>
  import('./FamiliesLearning').then((m) => ({ default: m.FamiliesLearning })),
)

export const LearnedResponse = lazyPreload(() =>
  import('./LearnedResponse').then((m) => ({ default: m.LearnedResponse })),
)

export const ListenTogether = lazyPreload(() =>
  import('./ListenTogether').then((m) => ({ default: m.ListenTogether })),
)

export const AngerCycle = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.AngerCycle })),
)

export const CalmFirstLesson = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.CalmFirstLesson })),
)

export const FinalTouch = lazyPreload(() =>
  import('./FinalTouch').then((m) => ({ default: m.FinalTouch })),
)

export const FaithGrowthProfile = lazyPreload(() =>
  import('./Profile').then((m) => ({ default: m.FaithGrowthProfile })),
)

export const FromUsers = lazyPreload(() =>
  import('./FromUsers').then((m) => ({ default: m.FromUsers })),
)

export const FromUsersFactory = lazyPreload(() =>
  import('./FromUsers').then((m) => ({ default: m.FromUsersFactory })),
)

export const FromUsersVariant3 = lazyPreload(() =>
  import('./FromUsers').then((m) => ({ default: m.FromUsersVariant3 })),
)

export const GodSpeakToYou = lazyPreload(() =>
  import('./GodSpeakToYou').then((m) => ({ default: m.GodSpeakToYou })),
)

export const GrowthProfile = lazyPreload(() =>
  import('./GrowthProfile').then((m) => ({ default: m.GrowthProfile })),
)

export const GuidanceQuotePage = lazyPreload(() =>
  import('./GuidanceQuotePage').then((m) => ({ default: m.GuidanceQuotePage })),
)

export const HardToNavigate = lazyPreload(() =>
  import('./HardToNavigate').then((m) => ({ default: m.HardToNavigate })),
)

export const IntroLoaderAyah = lazyPreload(() =>
  import('./Intro').then((m) => ({ default: m.IntroLoaderAyah })),
)

export const IntroLoaderKarma = lazyPreload(() =>
  import('./Intro').then((m) => ({ default: m.IntroLoaderKarma })),
)

export const IntroPrintable = lazyPreload(() =>
  import('./Intro').then((m) => ({ default: m.IntroPrintable })),
)

export const IntroPrintableAyah = lazyPreload(() =>
  import('./Intro').then((m) => ({ default: m.IntroPrintableAyah })),
)

export const JoinCommunity = lazyPreload(() =>
  import('./JoinCommunity').then((m) => ({ default: m.JoinCommunity })),
)

export const LetUsKnow = lazyPreload(() =>
  import('./LetUsKnow').then((m) => ({ default: m.LetUsKnow })),
)

export const LetUsKnowKarma = lazyPreload(() =>
  import('./LetUsKnow').then((m) => ({ default: m.LetUsKnowKarma })),
)

export const MillionSouls = lazyPreload(() =>
  import('./MillionSouls').then((m) => ({ default: m.MillionSouls })),
)

export const MoneyBreakV1 = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.MoneyBreakV1 })),
)

export const MoneyBreakV2 = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.MoneyBreakV2 })),
)

export const MoneyBreakV3 = lazyPreload(() =>
  import('./BreakScreenAyah').then((m) => ({ default: m.MoneyBreakV3 })),
)

export const Name = lazyPreload(() =>
  import('./Name').then((m) => ({ default: m.Name })),
)

export const NameV2 = lazyPreload(() =>
  import('./Name').then((m) => ({ default: m.NameV2 })),
)

export const NearRelief = lazyPreload(() =>
  import('./NearRelief').then((m) => ({ default: m.NearRelief })),
)

export const NextStep = lazyPreload(() =>
  import('./NextStep').then((m) => ({ default: m.NextStep })),
)

export const PeopleLikeYou = lazyPreload(() =>
  import('./PeopleLikeYou').then((m) => ({ default: m.PeopleLikeYou })),
)

export const PersonalGrowthProgressV2 = lazyPreload(() =>
  import('./PersonalGrowthProgress').then((m) => ({
    default: m.PersonalGrowthProgressV2,
  })),
)

export const PersonalGrowthProgressV3 = lazyPreload(() =>
  import('./PersonalGrowthProgress').then((m) => ({
    default: m.PersonalGrowthProgressV3,
  })),
)

export const PersonalizedPlanKarma = lazyPreload(() =>
  import('./AnimationStep').then((m) => ({ default: m.PersonalizedPlanKarma })),
)

export const Presence = lazyPreload(() =>
  import('./Presence').then((m) => ({ default: m.Presence })),
)

export const ProfileWType = lazyPreload(() =>
  import('./Profile').then((m) => ({ default: m.ProfileWType })),
)

export const ProfileSdAyah = lazyPreload(() =>
  import('./Profile').then((m) => ({ default: m.ProfileSdAyah })),
)

export const ParentingProfile = lazyPreload(() =>
  import('./Profile').then((m) => ({ default: m.ParentingProfile })),
)

export const DeenProfile = lazyPreload(() =>
  import('./Profile').then((m) => ({ default: m.DeenProfile })),
)

export const ReservedPlan = lazyPreload(() =>
  import('./ReservedPlan').then((m) => ({ default: m.ReservedPlan })),
)

export const RestfulNights = lazyPreload(() =>
  import('./RestfulNights').then((m) => ({ default: m.RestfulNights })),
)

export const Scratch = lazyPreload(() =>
  import('./Scratch').then((m) => ({ default: m.Scratch })),
)

export const SimpleIslam = lazyPreload(() =>
  import('./SimpleIslam').then((m) => ({ default: m.SimpleIslam })),
)

export const SpiritualityBenefits = lazyPreload(() =>
  import('./SpiritualityBenefits').then((m) => ({
    default: m.SpiritualityBenefits,
  })),
)

export { StableIntro } from './StableIntro'

export { StartQuizAyah } from './StartQuiz'

export const TaiChiEnergyFlow = lazyPreload(() =>
  import('./BreakScreenKarma').then((m) => ({ default: m.TaiChiEnergyFlow })),
)

export const ThankYou = lazyPreload(() =>
  import('./ThankYou').then((m) => ({ default: m.ThankYou })),
)

export const ThankYouV2 = lazyPreload(() =>
  import('./ThankYou').then((m) => ({ default: m.ThankYouV2 })),
)

export const TransformFaith = lazyPreload(() =>
  import('./TransformFaith').then((m) => ({ default: m.TransformFaith })),
)

export const TransformLife = lazyPreload(() =>
  import('./TransformLife').then((m) => ({ default: m.TransformLife })),
)

export const TransformLifeKarma = lazyPreload(() =>
  import('./AnimationStep').then((m) => ({ default: m.TransformLifeKarma })),
)

export const WantGoDeeper = lazyPreload(() =>
  import('./WantGoDeeper').then((m) => ({ default: m.WantGoDeeper })),
)

export const WelcomePath = lazyPreload(() =>
  import('./WelcomePath').then((m) => ({ default: m.WelcomePath })),
)

export const WritingYourStory = lazyPreload(() =>
  import('./WritingYourStory').then((m) => ({ default: m.WritingYourStory })),
)
